import { useEffect } from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import { AuthProvider } from "@mavenmm/teamwork-auth";
import { routes } from "./routes";
import { FeedbackRoot } from "./components/FeedbackMount";
import Layout from "./components/Layout";
import { useCurrentUser } from "./hooks/useCurrentUser";
import { setSentryUser } from "./lib/sentry";

// Auto-detection: localhost → localhost:9100, *.mavenmm.com → auth.mavenmm.com
const authConfig = {
  domainKey: import.meta.env.VITE_DOMAIN_KEY,
};

// Tags Sentry events with the signed-in user. Renders nothing.
function SentryUserSync() {
  const { user } = useCurrentUser();
  useEffect(() => {
    setSentryUser(
      user ? { id: user.id, email_address: user.email_address } : null
    );
  }, [user]);
  return null;
}

function App() {
  return (
    <BrowserRouter basename="/">
      <AuthProvider authConfig={authConfig}>
        <SentryUserSync />
        <FeedbackRoot>
        <Routes>
          {/* Main app routes */}
          <Route element={<Layout />}>
            {routes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                element={<route.component />}
              />
            ))}
          </Route>
        </Routes>
        </FeedbackRoot>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
